import videojs from '../../../node_modules/video.js/dist/video.js';

window.addEventListener('load', function () {
  if ($('.modal-trigger').length) {
    $('.modal-trigger').each(function () {
      //console.log(this);
      var thisModalTrigger = $(this).attr('data-modal'); // design
      var thisModal = $('#modal' + thisModalTrigger); // #modaldesign
      var player = videojs('modal' + thisModalTrigger + 'video', {
        //modaldesignvideo
        controls: true,
        autoplay: false,
        preload: 'auto',
        ratio: '16:9',
        fluid: true,
      });
      // When the user clicks on the button, open the modal
      $(this).on('click', function () {
        //console.log(this);
        thisModal.show();
        player.play();
      });
      $('.modal-bg, .close-btn, .coto_header').on('click', function () {
        thisModal.hide();
        player.pause();
      });
    });
  }
});

// modal without video
window.addEventListener('load', function () {
  if ($('.modalb-trigger').length) {
    $('.modalb-trigger').each(function () {
      //console.log(this);
      var thisModalTrigger = $(this).attr('data-modal'); // design
      var thisModal = $('#modal' + thisModalTrigger); // #modaldesign

      // When the user clicks on the button, open the modal
      $(this).on('click', function () {
        //console.log(this);
        thisModal.show();
        thisModal.addClass('active');
      });
      $('.modal-bg, .close-btn, .coto_header').on('click', function () {
        thisModal.hide();
        thisModal.removeClass('active');
      });
    });
  }
});
